import { combineReducers } from 'redux'

import { IApp, reducer as app } from './app'
import { IAuthenticate, reducer as auth } from './authenticate'

export default combineReducers({
  app,
  auth
})

export interface IRedux {
  auth?: IAuthenticate
  app?: IApp
}
